import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import * as Routes from '@/modules/routes';
import QueryKeys from '@/utils/QueryKeys';

// What the tree shows per section: the same facts as the sysadmin sections table (tutorial,
// reading check, notebooks). Fetched only once a lesson's Sections node opens.

export interface LessonSection {
  full_title: string;
  id: number;
  notebooks_count: number;
  reading_check_questions_count: number | null;
  reading_game_id: number | null;
  tutorial_id: number | null;
}

const useLessonSections = (lessonId: number, enabled: boolean) => useQuery({
  enabled,
  queryFn: async () => {
    const { data } = await axios.get(Routes.plato_api_lesson_sections_path(lessonId, {
      extra_attributes: [
        'full_title', 'tutorial_id', 'reading_game_id', 'reading_check_questions_count', 'notebooks_count',
      ],
      only: ['id'],
    }));
    return (data.data || []) as LessonSection[];
  },
  queryKey: [QueryKeys.Sections, lessonId, 'tree'],
});

export default useLessonSections;
